/**
 * @desc rich text
 * @author liwensheng
 */
import * as lodash from '../utils/lodash';
import TextNode from './nodes/text';
import parseVNode, { TagsMap } from './parser';
/**
 * rich text
 */
var RichText = /** @class */ (function () {
    function RichText(conf) {
        this.conf = conf;
        this.init();
    }
    RichText.prototype.init = function () {
        var text = this.conf.text;
        if (text && typeof text === 'object' && text.type) {
            this.node = this._createRichNode(text);
            return;
        }
        if (lodash.isNull(text) || lodash.isUndefined(text)) {
            text = '';
        }
        else {
            text = text.toString();
        }
        var result = parseVNode(text, this);
        this.node = result[0];
    };
    RichText.prototype.needRelayout = function () {
        if (!this._relayouted) {
            this._needRelayout = true;
        }
    };
    RichText.prototype.layout = function () {
        this.node.computeSize();
        var _a = this.conf, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.textAlign, textAlign = _d === void 0 ? 'left' : _d, _e = _a.textBaseline, textBaseline = _e === void 0 ? 'top' : _e;
        var _f = this.node.minSize, width = _f[0], height = _f[1];
        var left = x;
        var top = y;
        if (textAlign === 'left') {
            left = x;
        }
        else if (textAlign === 'center') {
            left = x - width / 2;
        }
        else if (textAlign === 'right') {
            left = x - width;
        }
        if (textBaseline === 'top') {
            top = y;
        }
        else if (textBaseline === 'middle') {
            top = y - height / 2;
        }
        else if (textBaseline === 'bottom') {
            top = y - height;
        }
        this.node.bbox.x = left;
        this.node.bbox.y = top;
        this.node.bbox.width = width;
        this.node.bbox.height = height;
        this.node.layout();
        if (this._needRelayout) {
            this._relayouted = true;
            this._needRelayout = false;
            this.layout();
        }
    };
    RichText.prototype.hasRelayouted = function () {
        return this._relayouted;
    };
    RichText.prototype.getBoxSize = function () {
        return { width: this.node.bbox.width, height: this.node.bbox.height };
    };
    RichText.prototype._createRichNode = function (obj) {
        var _this = this;
        var _a;
        var CNode = TagsMap[obj.type.toLowerCase()];
        var node = new CNode(obj);
        node.ownerDocument = this;
        (_a = obj.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
            if (child && typeof child === 'object' && child.type) {
                node.appendChild(_this._createRichNode(child));
            }
            else {
                node.appendChild(new TextNode({
                    value: child,
                }));
            }
        });
        return node;
    };
    return RichText;
}());
export default RichText;
